// src/hooks/useDrilldownSeries.ts
import { useMemo } from "react";
import useFetchGraphData from "../useFetchGraphData";
import { parseLocalDate } from "../../utils";

export default function useDrilldownSeries({
  parameterid,
  startDate,
  endDate,
  season,
  locationIds,
}) {
  const {
    data,
    isFetching: isLoading,
    isError,
  } = useFetchGraphData(
    {
      parameterid,
      start_date: startDate,
      end_date: endDate,
      season,
      locationIds: locationIds.join(","),
    },
    "results-simple/wq-parameter-viewer/drilldown"
  );

  const { seriesByLoc, unit, parameter } = useMemo(() => {
    if (!data?.length) return { seriesByLoc: {}, unit: "", parameter: "" };
    const byLoc = {};
    data.forEach((d) => {
      if (!byLoc[d.location_name]) byLoc[d.location_name] = [];
      byLoc[d.location_name].push({
        date: parseLocalDate(d.rdate),
        value: d.rvalue_converted,
      });
    });
    return {
      seriesByLoc: byLoc,
      unit: data[0].unit_name,
      parameter: data[0].parameter,
    };
  }, [data]);

  return { seriesByLoc, unit, parameter, isLoading, isError };
}
